import { combineReducers } from '@reduxjs/toolkit';
import auth from 'app/auth/store';
import admin from 'app/main/apps/admin/ducks';
import { merchantListFiltersReducer as merchantListFilters } from 'app/main/apps/admin/ducks/merchantListFilters.slice';
import marketing from 'app/main/apps/automatedMarketing/ducks';
import categories from 'app/main/apps/categories/ducks';
import notificationCampaign from 'app/main/apps/communicationCampaign/ducks';
import { reducer as franchiseProducts } from 'app/main/apps/communicationCampaign/ducks/franchiseProduct.slice';
import crm from 'app/main/apps/crm/ducks';
import eMarketing from 'app/main/apps/eMarketing/ducks';
import forms from 'app/main/apps/forms/ducks';
import franchises from 'app/main/apps/franchises/ducks';
import games from 'app/main/apps/games/ducks';
import googleReviews from 'app/main/apps/googleReviews/ducks';
import listCategory from 'app/main/apps/listCategory/ducks';
import loyaltiesApp from 'app/main/apps/loyalties/ducks';
import prono from 'app/main/apps/prono/ducks';
import referral from 'app/main/apps/referral/ducks';
import satisfaction from 'app/main/apps/satisfaction/ducks';
import storesApp from 'app/main/apps/stores/ducks';
import visibility from 'app/main/apps/visibility/ducks';
import webPush from 'app/main/apps/webPush/ducks';
import clients from 'app/main/pages/clients/ducks';
import fuse from './fuse';

const createReducer = (asyncReducers: object) =>
  combineReducers({
    auth,
    fuse,
    storesApp,
    notificationCampaign,
    franchiseProducts,
    categories,
    clients,
    crm,
    satisfaction,
    franchises,
    eMarketing,
    loyaltiesApp,
    marketing,
    admin,
    merchantListFilters,
    games,
    googleReviews,
    listCategory,
    forms,
    prono,
    referral,
    webPush,
    visibility,
    ...asyncReducers,
  });

export default createReducer;
